import * as Common from "../commons/common";

import Axios from 'axios';
const http = Axios.create({
  withCredentials: true,
});

http.interceptors.response
  .use(
    response => response,
    (error) => {
      
      let isLoginError = false;
      
      if(error.response){
        if (error.response.data && error.response.data.error) {
          isLoginError = error.response.data.error.indexOf("login_failed") != -1
        }
  
        // ステータスコード:401でログインエラー以外の認証エラーの場合はログイン画面に戻る
        if(!isLoginError && (error.response.status == 401 || error.response.status == 302)){
          
          const url = window.location.href;
          
          if(url.indexOf("student_site") != -1){

            if(Common.getCookieValue(document.cookie, "api_kind") == "sso_student_login"){
              // SSOの場合はウィンドウを閉じる
              document.cookie = 'access_token=';
              document.cookie = 'smarky_user_id=';
              document.cookie = 'smarky_is_parent=';
              const msg = error.response.status == 401 ? "認証に失敗しました。ブラウザを終了します。" : "サーバーとの通信が一定時間行われなかったため、セッションが切れました。ブラウザを終了します。";
              alert(msg);
              window.close();
            }else{
              // 生徒サイトのログイン画面へ 
              document.cookie = 'access_token=';
              document.cookie = 'smarky_user_id=';
              document.cookie = 'smarky_is_parent=';
              const ary = url.split("/");
              const index = ary.indexOf("#") + 1;

              if(ary.length < index + 1 || ary[index] == null || ary[index] == undefined){
                alert("エラーが発生しました。\n一度ブラウザを閉じてから再度ログインページにアクセスしてください。");
              }else{
                window.location.href = `/#/${ary[index]}/student_site/sign_in`;
              }
            }
          }else{
            // 教師サイトログイン画面へ
            document.cookie = 'access_token=';
            document.cookie = 'smarky_user_id=';
            document.cookie = 'smarky_is_parent=';
            window.location.href="/#/";
          }
          return;
        }else if(error.response.status == 500){
          if(error.response.data.errors !== undefined && error.response.data.stack !== undefined){
            console.log(error.response.data.errors[0]);
            console.log(error.response.data.stack);
          }
        }
      }
      
      return Promise.reject(error);
    });

export default http;
